import * as zod from "zod/v4";
import { RateCalculatorSessionConfigSchema } from "./rate-calculator-session-config";

export const saveRateCalculatorSession = {
  name: "saveRateCalculatorSession" as const,
  input: zod.object({
    sessionId: zod.string().nullable(),
    sessionName: zod.string().nullable(),
    teamId: zod.string().nullable(),
    teamName: zod.string().nullable(),
    configState: RateCalculatorSessionConfigSchema,
    uploadedFileName: zod.string().nullable(),
  }),
  output: zod.object({ sessionId: zod.string() }),
};
